var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3914_78417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8985 9.00023C37.4475 8.98016 41.9003 10.3095 45.6938 12.8201C49.4872 15.3307 52.451 18.9099 54.2103 23.1049C55.9696 27.3 56.4454 31.9225 55.5775 36.388C54.7097 40.8534 52.5371 44.9613 49.3346 48.192C46.1321 51.4227 42.0435 53.6312 37.5858 54.5382C33.1281 55.4452 28.5016 55.0099 24.2912 53.2875C20.0809 51.565 16.4759 48.6328 13.9321 44.8614C11.3884 41.0901 10.02 36.6492 10.0002 32.1002C9.97364 26.0005 12.3712 20.1401 16.6654 15.808C20.9596 11.4759 26.7988 9.02713 32.8985 9.00023Z",
    fill: "#006AED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0583 21.1826C27.0105 21.192 26.9654 21.2088 26.9202 21.2242C26.8958 21.2328 26.8705 21.2368 26.8464 21.2471C26.796 21.2684 26.7495 21.2953 26.7026 21.3235C26.6862 21.3329 26.6681 21.3403 26.652 21.3506C26.5904 21.3919 26.5329 21.4384 26.4806 21.4903L21.3321 26.5969C20.8893 27.0361 20.8893 27.7474 21.3321 28.1868C21.7743 28.626 22.492 28.626 22.9351 28.1868L26.1494 24.999V41.6368C26.1494 42.258 26.6569 42.761 27.2828 42.761C27.909 42.761 28.4162 42.2576 28.4162 41.6368V24.999L31.6311 28.1877C32.0733 28.6269 32.791 28.6269 33.2341 28.1877C33.4555 27.9681 33.5662 27.6806 33.5662 27.3928C33.5662 27.1051 33.4552 26.8176 33.2341 26.598L28.0847 21.4903C28.0324 21.4383 27.9746 21.3919 27.9133 21.3505C27.8972 21.3402 27.8791 21.3328 27.8627 21.3234C27.8161 21.2957 27.7693 21.2681 27.7189 21.247C27.6951 21.2373 27.6695 21.2327 27.6451 21.2242C27.5996 21.209 27.5548 21.1922 27.507 21.1825C27.4337 21.1683 27.359 21.16 27.2828 21.16C27.2066 21.16 27.1316 21.1683 27.0583 21.1826ZM37.5834 22.5233V39.1611L34.3685 35.9724C33.9263 35.5332 33.2086 35.5332 32.7655 35.9724C32.3225 36.4116 32.3227 37.1229 32.7655 37.5623L37.9152 42.67C37.9676 42.7219 38.0254 42.7684 38.0866 42.8098C38.1021 42.8195 38.1197 42.8266 38.1352 42.8354C38.1821 42.8637 38.2295 42.8919 38.281 42.9127C38.3046 42.9221 38.3296 42.9267 38.3534 42.9353C38.3992 42.9504 38.4446 42.9675 38.4929 42.9775C38.5662 42.9923 38.641 43 38.7172 43C38.7934 43 38.8681 42.9923 38.9414 42.9775C38.9897 42.9681 39.0349 42.9509 39.0809 42.9353C39.1048 42.9267 39.1301 42.9227 39.1534 42.9127C39.2045 42.8913 39.252 42.8637 39.2991 42.8354C39.3147 42.8263 39.3322 42.8195 39.3477 42.8098C39.4093 42.7684 39.4668 42.7219 39.5191 42.67L44.6679 37.5632C44.8893 37.3436 45 37.0561 45 36.7683C45 36.4806 44.889 36.1931 44.6679 35.9735C44.2257 35.5343 43.508 35.5343 43.0649 35.9735L39.8506 39.1613V22.5235C39.8506 21.9023 39.3431 21.3993 38.7172 21.3993C38.0912 21.3993 37.5834 21.9021 37.5834 22.5233Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3914_78417",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3914_78417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3914_78417",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.c7740abde72536a3140240c4fd6003c1.svg";
export { ForwardRef as ReactComponent };